"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetLocalBannerResponse = exports.isCookieBannerResponseValid = exports.getCookieBannerResponse = exports.setCookieBannerResponse = exports.BANNER_STORAGE_KEY = void 0;
const storage_1 = require("../../utils/storage");
exports.BANNER_STORAGE_KEY = "SOCS";
const ONE_YEAR_MILLISECONDS = 1000 * 60 * 60 * 24 * 365;
const ONE_WEEK_MILLISECONDS = 1000 * 60 * 60 * 24 * 7;
// this is used in the event that localStorage is unavailable
let fallbackCookieBannerResponse = null;
function setCookieBannerResponse(status) {
    if (!(0, storage_1.isStorageAvailable)("localStorage")) {
        fallbackCookieBannerResponse = status;
        return;
    }
    localStorage.setItem(exports.BANNER_STORAGE_KEY, JSON.stringify({
        status,
        timestamp: Date.now(),
    }));
}
exports.setCookieBannerResponse = setCookieBannerResponse;
function getCookieBannerResponse() {
    if (!(0, storage_1.isStorageAvailable)("localStorage")) {
        return fallbackCookieBannerResponse;
    }
    const storedResponse = localStorage.getItem(exports.BANNER_STORAGE_KEY);
    if (!storedResponse)
        return null;
    const parsedResponse = JSON.parse(storedResponse);
    return isCookieBannerResponseValid(parsedResponse)
        ? parsedResponse.status
        : null;
}
exports.getCookieBannerResponse = getCookieBannerResponse;
function isCookieBannerResponseValid({ status, timestamp, }) {
    if (status !== "accepted" && status !== "declined")
        return false;
    const validTimePeriod = status === "accepted" ? ONE_YEAR_MILLISECONDS : ONE_WEEK_MILLISECONDS;
    return timestamp + validTimePeriod > Date.now();
}
exports.isCookieBannerResponseValid = isCookieBannerResponseValid;
function resetLocalBannerResponse() {
    fallbackCookieBannerResponse = null;
}
exports.resetLocalBannerResponse = resetLocalBannerResponse;
//# sourceMappingURL=CookieBanner.utils.js.map